import Vue from "vue";
import Router from "vue-router";
import { request_post, datatb_post_new } from "../api/api";

Vue.use(Router);

function getAbsolutePath() {
  let path = location.pathname;
  console.log(path.substring(0, path.lastIndexOf("/") + 1));
  return path.substring(0, path.lastIndexOf("/") + 1);
}

const router = new Router({
  base: getAbsolutePath(),
  // mode: "history",
  routes: [
    {
      path: "/login",
      name: "登录",
      component: () => import("../views/login/Login.vue")
    },
    {
      path: "/wx/login",
      name: "微信登录",
      component: () => import("../views/login/WxLogin.vue")
    },
    {
      path: "/",
      name: "首页",
      component: () => import("../views/home/Home.vue"),
      children: [
        {
          path: "/index",
          name: "首页信息",
          component: () => import("../views/index/Index.vue")
        },
        {
          path: "/person/list",
          name: "员工列表",
          component: () => import("../views/person/list/PersonList.vue")
        },
        {
          path: "/person/lists",
          name: "员工列表",
          component: () => import("../views/person/lists/lists.vue")
        },
        {
          path: "/person/persondetails",
          name: "员工列表详情",
          component: () => import("../views/person/lists/persondetails.vue")
        },
        {
          path: "/prove/list",
          name: "证明申请列表",
          component: () => import("../views/prove/list/ProveList.vue")
        },
        {
          path: "/prove/provedetail",
          name: "证明申请详情",
          component: () => import("../views/prove/lists/provedetail.vue")
        },
        {
          path: "/prove/lists",
          name: "证明申请列表",
          component: () => import("../views/prove/lists/provelist.vue")
        },
        {
          path: "/approval/mission",
          name: "审批任务",
          component: () =>
            import("../views/approval/mission/ApprovalMission.vue")
        },
        {
          path: "/approval/task",
          name: "审批任务",
          component: () => import("../views/approval/task/task.vue")
        },
        {
          path: "/approval/infotask",
          name: "信息变更",
          component: () =>
            import("../views/approval/task/infotask/infotask.vue")
        },
        {
          path: "/approval/provetask",
          name: "工作及收入证明",
          component: () =>
            import("../views/approval/task/provetask/provetask.vue")
        },
        {
          path: "/approval/setting",
          name: "审批设置",
          component: () =>
            import("../views/approval/setting/ApprovalSetting.vue")
        },
        {
          path: "/lvli/list",
          name: "履历设置",
          component: () => import("../views/lvli/LvliList.vue")
        },
        {
          path: "/datacheck/datacheck",
          name: "数据核查管理",
          component: () => import("../views/approval/datacheck/datacheck.vue")
        },
        {
          path: "/checkhistory/checkhistory",
          name: "核查历史记录",
          component: () =>
            import("../views/approval/checkhistory/checkhistory.vue")
        },
        {
          path: "/data/datalist",
          name: "数据报表",
          component: () => import("../views/datareport/DataReport.vue")
        },
        {
          path: "/data/detailstable",
          name: "详情报表",
          component: () =>
            import("../views/datareport/detailstable/detailstable.vue")
        },
        {
          path: "/data/summarytable",
          name: "概要报表",
          component: () =>
            import("../views/datareport/summarytable/summarytable.vue")
        },
        {
          path: "/statistic/statistic",
          name: "统计分析",
          component: () => import("../views/statistic/Statistic.vue")
        },
        {
          path: "/setting/workbench",
          name: "工作台设置",
          component: () =>
            import("../views/setting/workbench/SettingWorkbench.vue")
        },
        {
          path: "/setting/newworkbench",
          name: "工作台设置",
          component: () =>
            import("../views/setting/newworkbench/SettingWorkbench.vue")
        },

        {
          path: "/setting/swiper",
          name: "轮播图管理",
          component: () => import("../views/setting/swiper/Swiper.vue")
        },
        {
          path: "/setting/backgroundPage",
          name: "底图配置",
          component: () => import("../views/setting/backgroundPage/backgroundPage.vue")
        },
        {
          path: "/setting/messagePush",
          name: "企业微信消息推送模板配置",
          component: () => import("../views/setting/messagePush/messagePush.vue")
        },
        {
          path: "/setting/swiper/addswiper",
          name: "添加轮播图",
          component: () => import("../views/setting/swiper/AddSwiper.vue")
        },
        {
          path: "/setting/updateInfo",
          name: "更新提示",
          component: () => import("../views/setting/updateInfo/updateInfo.vue")
        },
        {
          path: "/setting/publicity",
          name: "公示管理",
          component: () => import("../views/setting/publicity/Publicity.vue")
        },
        {
          path: "/setting/manbanner",
          name: "Banner白名单管理",
          component: () => import("../views/setting/manbanner/ManBanner.vue")
        },
        {
          path: "/setting/background",
          name: "移动台背景",
          component: () => import("../views/setting/background/Background.vue")
        },
        {
          path: "/setting/news",
          name: "消息中心",
          component: () => import("../views/setting/news/News.vue")
        },
        {
          path: "/score/scoreconfig",
          name: "积分配置",
          component: () => import("../views/score/config/Config.vue")
        },
        {
          path: "/authority/application",
          name: "应用管理中心",
          component: () => import("../views/authority/application/ResourceManage.vue")
        },
        {
          path: "/authority/authorization",
          name: "权限中心",
          component: () => import("../views/authority/authorization/AuthManage.vue")
        }
      ]
    }
  ]
});

let state = 1;

router.beforeEach(async (to, from, next) => {
  // 如果用户访问的时登录页面，清除登录信息并跳转到登录页面
  // 如果用户访问除登录页以外的页面，则验证是否登录过，未登录跳转到登录，已登录则进入访问页面

  let num = to.path.indexOf("/login");

  // if (num != -1) {

  if (to.path === "/login" || to.path === "/wx/login") {
    // 访问登录页，清空登录信息并跳转
    window.localStorage.removeItem("login");

    next();
  } else {
    // 访问业务页面，验证登录信息
    console.dir(to);
    // var state = 1
    if (to.path === "/sso" && state === 1) {
      state = 2;
      console.log(state);
      let userId = to.query.user_id;
      let result = await request_post(`/auth/sso/login?user_id=${userId}`);
      if (result["code"] === 200) {
        window.localStorage.setItem("login", JSON.stringify(result["data"]));
        next("/index");
      } else {
        next("/login");
      }

      /*var da = {
        // avatar: "http://localhost:30125/avatar.jpg",
        nickname: "吴娜娜",
        role: "system",
        token: "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJqdWJmIiwiZXhwIjoxNjA0MzkxODM0LCJib2R5Ijoie1wiZXhwaXJhdGlvblwiOjE2MDQzOTE4MzQxNTMsXCJyb2xlXCI6XCJzeXN0ZW1cIixcInVzZXJJZFwiOlwiMVwifSIsImlhdCI6MTYwNDM4NDYzNH0.vOB6kjrj2WK5yoHotzxUSIHVFiRTNvEsicy8uEYm3s_rQwdjFdqVqdotCtwUYeXZQh259FJCCo826DJpOXnrXQ",
        userId: "1",
      };


      window.localStorage.setItem("login", JSON.stringify(da));


      let login = window.localStorage.getItem("login");

      next()

      if (state === 2) {
        console.log('进来了');

      }*/
    } else {
      state = 1;
      let login = window.localStorage.getItem("login");
      if (!login) {
        // 登录信息不存在，直接跳转登录页
        next("/login");
      } else {
        // next();
        // return
        // 验证登录信息是否正确


        login = JSON.parse(login);
        // console.log(result.data);
        // login.token = login.data.token;
        window.localStorage.setItem("login", JSON.stringify(login));
        if (to.path === "/") {
          next("/index");
        } else {
          next();
        }


        // let result = await datatb_post_new("/auth/verify", null);
        // if (result["code"] === 200) {
        //   login = JSON.parse(login);
        //   // console.log(result.data);
        //   login.token = result["data"];
        //   window.localStorage.setItem("login", JSON.stringify(login));
        //   if (to.path === "/") {
        //     next("/index");
        //   } else {
        //     next();
        //   }
        // } else {
        //   next("/login");
        // }
      }
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js